<template>
  <ul class="product-badges">
    <li
      v-for="badge of badges"
      :key="badge"
      class="product-badges__item text-other-label-s text-other-label-l-desktop"
      v-text="badge"
    />
  </ul>
</template>

<script>

/**
 * Vue: Product badges (product-badges)
 * -----------------------------------------------------------------------------
 * Metafield based product badges displayed in product card and PDP.
 * - Component settings: snippet / dynamic / async / scroll
 *
 * @param {Array} badges - Product badges.
 * @param {Boolean} [loading] - Loading state.
 *
 */
export default {
  name: 'ProductBadges',

  props: {
    badges: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
@import './product-badges';
</style>
